import RemoveIcon from "../images/RemoveIcon";

const CloseButton = ({ onClick }) => {
  return (
    <button onClick={onClick}>
      <RemoveIcon size={24} />
    </button>
  );
};

export default CloseButton;
